import React from "react";

const Comparison = () => {
  return (
    <div>
      <h1>Comparison Component</h1>
      <p>Content for Comparison goes here...</p>
    </div>
  );
};

export default Comparison;
